import React, { useEffect, useState } from "react";
import { IEvent } from "@eagerdog/interfaces";

import { Modal } from "src/components/Modal/Modal";
import ShareToFeedModal from "./ShareToFeedModal";
import { subscribeShareToFeed } from "./shareToFeedPrompt";

/** Mounted once in App; opens the "Share to feed" modal when a publish path asks. */
const ShareToFeedModalHost: React.FC = () => {
    const [event, setEvent] = useState<IEvent | null>(null);

    useEffect(() => subscribeShareToFeed((e) => setEvent(e)), []);

    const close = () => setEvent(null);

    return (
        <Modal
            className="shareToFeedModal"
            isShown={!!event}
            hide={close}
            modalContent={event ? <ShareToFeedModal event={event} onClose={close} /> : <></>}
        />
    );
};

export default ShareToFeedModalHost;
